import React from 'react';

export default function SelectFilter({ value, onChange, col }) {
  const options  = col?.filterOptions || [];
  const labels   = col?.filterLabels  || {};
  const selected = new Set(value?.values || []);

  const toggle = (opt) => {
    const next = new Set(selected);
    next.has(opt) ? next.delete(opt) : next.add(opt);
    onChange(next.size === 0 ? undefined : { op: 'in', values: [...next] });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {options.map(opt => (
        <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '3px 0' }}>
          <input
            type="checkbox"
            checked={selected.has(opt)}
            onChange={() => toggle(opt)}
            style={{ accentColor: 'var(--accent)', cursor: 'pointer' }}
          />
          <span style={{ fontSize: 12, color: 'var(--text-primary)' }}>
            {labels[opt] || opt}
          </span>
        </label>
      ))}
    </div>
  );
}
